// Angular imports
import { Injectable } from '@angular/core';

// Rxjs imports
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ConfigurationService {
    private readonly _subjectForceRefresh: Subject<boolean> = new Subject();
    private readonly _subjectContext: Subject<string> = new Subject(); // to send selected context (ex: M1, L10...) to component in router-outlet

    getSubjectForceRefresh(): Subject<boolean> {
        return this._subjectForceRefresh;
    }

    updateSubjectForceRefresh(flag: boolean): void {
        this._subjectForceRefresh.next(flag);
    }

    getSubjectContext(): Subject<string> {
        return this._subjectContext;
    }

    updateSubjectContext(newContext: string): void {
        this._subjectContext.next(newContext);
    }
}
